



































































































import { Component, Vue, Watch } from 'vue-property-decorator'; // デコレータ
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
import router from '../../router';
/* 以下画面固有 */
import { orderUsersModule } from '../../Kanri/store/modules/OrderUsers'; // ストアモジュール
import { ITree } from '../../Kanri/store/dto/Organization'; // dto
import { uketsukeManagementModule } from '../store/modules/UketsukeManger';
import { applicationFormModule } from '../store/modules/ApplicationForm';
// 定数
import { Constants } from '../../CommonUtils/fixed/Constants'; // 定数保管ファイル
import { Message } from '../../CommonUtils/fixed/Message'; // メッセージ
import { ScreenName } from '../../CommonUtils/fixed/ScreenName';
import { UketsukeScreenName } from '../fixed/UketsukeScreenName';
import { UketsukeConstants } from '../fixed/UketsukeConstants';
import { AuthoritiesId } from '@/CommonUtils/fixed/AuthoritiesId';
// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);

@Component
export default class PasswordIssuerSearch extends ApiAccessBase {
  // 拡張パネルの設定（検索条件）
  private searchPanel: number[] = [0];  //初期表示展開
  // 検索結果ヘッダの設定
  private headers = [{}];
  //ID設定変数
  private createElementId: string = '';
  private searchElementId: string = '';
  // ページネーション部品の初期値設定
  private page = 1;  // 初めに表示するページの番号（基本的に1で固定）
  private itemPerPage = 10; // 1ページあたりに表示するレコードの数
  private pageCount =  0; // ページカウントの初期化(0固定)
  // 権限情報
  private issueAuthority: boolean = false;

  // 画面初期化処理
  // component生成時に実行
  private created() {
    this.screenTitle = 'パスワード発行業者検索';
    // 使用する可変項目の名前を指定(複数指定可)
    this.createElementId = 'pass_issuer_search';
    this.searchElementId = 'pass_issuer_search_result';

    this.setVariablecolsState([this.createElementId]);
    //this.setVariablecolsState(['search_app_const']);
    const path: string = UketsukeConstants.PASS_ISSUER_PATH + '/init/search';

    // 権限の取得
    this.issueAuthority = this.checkAuthority(AuthoritiesId.ORD_CREATE);

    // APIアクセス
    this.apiAccess(path, Constants.API_METHOD_GET, false, false)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        //検索結果.ボタンの設定
        this.headers.shift(); //先頭の空白列削除
        //検索結果.DBから展開
        for (const item of this.variablecols[this.searchElementId] ) {
          this.headers.push({text: item.label, align: item.align, sortable: item.sortable, value: item.name, width: item.width});
        }
        this.headers.push(
        {text: 'パスワード発行', align: 'center', sortable: false, value: 'check', width: 90});
        // 再検索
        if (applicationFormModule.CHECK_RE_SEARCH) {
          this.formData = applicationFormModule.GET_FORM_DATA;
          this.syncFormDataToVariableCols();
          this.search();
        }
      }
    });
  }

  /**
   * パスワード発行処理
   */
  private passIssue(acceptNo : string, traderId : string, companyName : string ) {
    if (window.confirm(Message.I027 + companyName)) {
      this.apiAccess(UketsukeConstants.PASS_ISSUER_PATH + '/' + applicationFormModule.GET_APP_TYPE + '/' + acceptNo + '/' + traderId, Constants.API_METHOD_POST, false, null)
      .then((result) => {
        // 排他処理は行わない
        if (result === Constants.API_RESULT_SUCCES) {
          applicationFormModule.setAcceptNo(acceptNo);
          applicationFormModule.setTraderId(traderId);
          router.push({name: UketsukeScreenName.PASSWORD_ISSUE_RESULT});
        } else {
          // TOPへジャンプ
          this.hrefElement('searchPasswordIssuer', -50);
        }
      });
    }
  }

  /**
   * パスワード発行対象業者の検索
   * (検索ボタン押下時に発火)
   */
  private search() {
    // formのバリデーション
    if (!this.validateForm(this.$refs.form)) {
      return;
    }
    this.apiAccess(UketsukeConstants.PASS_ISSUER_PATH + '/' + applicationFormModule.GET_APP_TYPE, Constants.API_METHOD_POST, true, true)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        applicationFormModule.setFormData(this.formData);
        // 検索一覧の先頭へジャンプ
        this.hrefElement('searchResults', -50);
      } else {
        // TOPへジャンプ
        this.hrefElement('searchPasswordIssuer', -50);
      }
    });
  }

  /**
   * 検索条件のクリア
   */
  private reset() {
    this.resetForm(this.$refs.form);
    this.resultData = [];
    const path: string = UketsukeConstants.PASS_ISSUER_PATH + '/init/search';
    // APIアクセス
    this.apiAccess(path, Constants.API_METHOD_GET, false, false)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
      }
    });
  }
}
